





































































import Vue from 'vue';
import { FormDataInterface } from '@/types';

export default Vue.extend({
  name: 'FieldInput',
  props: {
    name: { type: String },
    value: {
      type: [String, Number],
      required: false,
      default: '',
    },
    placeholder: { type: String },
    label: { type: String },
    hint: { type: String },
    autosize: {
      type: Boolean,
      default: true,
    },
    minHeight: {
      type: Number,
      default: 30,
    },
    maxHeight: {
      type: Number,
      default: 500,
    },
    minWord: {
      type: Number,
      default: 0,
    },
    maxWord: {
      type: Number,
      default: 0,
    },
    maxSymbol: {
      type: Number,
      default: 0,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    important: {
      type: [Boolean, Array],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Number,
      default: 2,
    },
    dataTestId: {
      type: String,
      required: false,
      default: '',
    }
  },
  mounted(): void {
    if (this.value == null || this.value == 'null') {
      this.fieldValue = '';
    } else {
      this.fieldValue = this.value + '';
    }
    this.resize();
  },
  watch: {
    value: function(value) {
      this.fieldValue = value;
    },
    fieldValue(val) {
      this.$nextTick(this.resize);
      this.$emit('input', val);
    },
    minHeight() {
      this.$nextTick(this.resize);
    },
    maxHeight() {
      this.$nextTick(this.resize);
    },
    autosize(val) {
      if (val) this.resize();
    },
  },
  computed: {
    getId(): string {
      if (!this.name) {
        return (
          '_' +
          Math.random()
            .toString(36)
            .substr(2, 9)
        );
      }
      return this.name
        .replace('[', '-')
        .replace(']', '')
        .toLowerCase();
    },
    issetLabel(): boolean {
      return this.label !== '';
    },
    isFilled(): boolean {
      return this.fieldValue !== null && this.fieldValue !== '';
    },
    error(): string {
      return this.errors.join(', ');
    },
    errorCountWord(): boolean {
      return this.maxWord < this.countWord || this.minWord > this.countWord;
    },
    errorCountSymbol(): boolean {
      return this.maxSymbol < this.countSymbol;
    },
    wordsLeft(): number {
      if (!this.maxWord) {
        return 0;
      }
      return this.maxWord - this.countWord;
    },
    symbolLeft(): number {
      if (!this.maxSymbol) {
        return 0;
      }
      return this.maxSymbol - this.countSymbol;
    },
    widthProgressBar(): number {
      if (this.maxWord) {
        const count = this.countWord;
        if (!count) {
          return 0;
        }
        const width = (count / this.maxWord) * 100;
        if (width > 100) {
          return 100;
        }
        return width;
      }
      return 0;
    },
    widthProgressBarSymbol(): number {
      if (this.maxSymbol) {
        const count = this.countSymbol;
        if (!count) {
          return 0;
        }
        const width = (count / this.maxSymbol) * 100;
        if (width > 100) {
          return 100;
        }
        return width;
      }
      return 0;
    },
    countWord(): number {
      const stringTxt = this.fieldValue
        .replace(/\r\n|\r|\n/g, ' ')
        .replace(/\n/, ' ')
        .replace(/-\W/gi, ' ')
        .replace(/\s{2,}/gi, ' ')
        .replace(/ $/, '')
        .replace(/^ /, '')
        .replace(/ \– /gi, ' ')
        .replace(/ \- /gi, ' ');
      let stringArr: Array<string> = [];
      if (stringTxt !== '') {
        stringArr = stringTxt.split(' ');
      }
      return stringArr.length;
    },
    countSymbol(): number {
      return this.fieldValue?.length ?? 0;
    },
    computedStyles(): FormDataInterface {
      if (!this.autosize) return {};
      return {
        resize: !this.isResizeImportant ? 'none' : 'none !important',
        height: this.height,
        overflow: this.maxHeightScroll
          ? 'auto'
          : !this.isOverflowImportant
          ? 'hidden'
          : 'hidden !important',
      };
    },
    isResizeImportant(): boolean {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes('resize'));
    },
    isOverflowImportant(): boolean {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes('overflow'));
    },
    isHeightImportant(): boolean {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes('height'));
    },
  },
  methods: {
    resize() {
      this.$emit('focus');
      const important = this.isHeightImportant ? 'important' : '';
      this.height = `auto${important ? ' !important' : ''}`;
      this.$nextTick(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        let contentHeight = this.$refs.textArea?.scrollHeight + 1;
        if (this.minHeight) {
          contentHeight =
            contentHeight < this.minHeight ? this.minHeight : contentHeight;
        }
        if (this.maxHeight) {
          if (contentHeight > this.maxHeight) {
            contentHeight = this.maxHeight;
            this.maxHeightScroll = true;
          } else {
            this.maxHeightScroll = false;
          }
        }
        const heightVal = contentHeight + 'px';
        this.height = `${heightVal}${important ? ' !important' : ''}`;
      });
      return this;
    },
    input() {
      this.$emit('input', this.fieldValue.toString());
    },
    change() {
      this.$emit('change', this.fieldValue.toString());
    },
  },
  data: function() {
    return {
      fieldValue: '' as string,
      // works when content height becomes more then value of the maxHeight property
      maxHeightScroll: false,
      height: 'auto',
    };
  },
});
